/**
 * 系統相關 actions
 */

import * as actionTypes from '../actionTypes';

// 系統是否在維護中
export const setIsMaintenance = (data) => ({
  type: actionTypes.SET_IS_MAINTENANCE,
  data,
});
